import { NgModule } from '@angular/core';
import { ModuleRegistry, AllCommunityModule, provideGlobalGridOptions } from 'ag-grid-community';
import { AllEnterpriseModule } from 'ag-grid-enterprise';
import { AgGridModule } from 'ag-grid-angular';

@NgModule({
  imports: [AgGridModule],
  exports: [AgGridModule],
})
export class AppAgGridModule {
  constructor() {
    ModuleRegistry.registerModules([AllCommunityModule, AllEnterpriseModule]);

    provideGlobalGridOptions({ theme: 'legacy' });
  }
}
